<template>
  <li class="container flex sb_start" @mouseenter="showForceBox = true" @mouseleave="showForceBox = false">
    <div class="cover-img" :title="houseItem.title" target="_blank">
      <img v-if="houseItem.houseLayoutImg" class="all" :src="houseItem.houseLayoutImg | returnImage" />
      <img v-else class="all" :src="defaultCover" />
      <img v-if="houseItem.vrUrl" class="vr-logo" src="@/assets/imgs/icon_vr_gold.gif" />
    </div>
    <div class="info">
      <div class="flex s_center">
        <div class="info-title ellipsis size22 black bold" style="max-width:495px">{{ houseItem.title }}</div>
        <span v-show="mustSee" class="good-house">{{ mustSeeTag }}</span>
      </div>
      <div class="mt20 col66 relative">
        <!-- <div class="flood flex s_center">
                    <i class="el-icon-location-outline size16 mr10" />
                    <router-link to="/">{{houseItem.address}}</router-link>
                </div> -->
        <div class="flex s_center ellipsis" style="max-width:510px">
          <i class="el-icon-s-home size16 mr10" />
          <span class="pr5"
            v-if="houseItem.currentFloor || houseItem.totalFloor">{{ houseItem.currentFloor || "" }}{{ houseItem.totalFloor ? `共(${houseItem.totalFloor}层)` : '' }}</span>
          <span class="pr5" v-if="houseItem.room || houseItem.hall"> |
            {{ houseItem.room ? houseItem.room + "室" : "" }}{{ houseItem.hall ? houseItem.hall + "厅" : "" }} </span>
          <span class="pr5" v-if="houseItem.buildingArea"> | {{ houseItem.buildingArea }}平米</span>
          <span v-if="houseItem.orientation !== '未选择'"> | {{ houseItem.orientation }}</span>
          <span v-if="houseItem.decorate">{{ decorateTag }}</span>
        </div>
        <ul v-if="houseItem.tag && houseItem.tag.length" class="flex wrap mt20">
          <li v-for="tag in houseItem.tag" :key="tag" class="tag">{{ tag }}</li>
        </ul>
        <div class="tags mt10" v-if="houseItem.floorLocate || Number(houseItem.totalFloor) < 1">
          <i class="el-icon-location size16 mr10" />
          <span>
            {{ houseItem.floorLocate }}{{ '(共' + houseItem.totalFloor + '层)' }}</span>
        </div>
        <div class="tags mt10">
          <i class="el-icon-star-on size16 mr10" />
          <span> {{ !listingPriceTag ? '' : '挂牌' + listingPriceTag + '万 / ' }}
            {{ '成交周期' + houseItem.dealCycle + '天' }}</span>
        </div>
        <div class="price-info row">
          <div class="date-time column right">
            <span class="size22 bold">
              {{ houseItem.dealDate || '' }}
            </span>
            <span class="mt10 black" v-if="houseItem.unitPrice"> {{ houseItem.unitPrice + '元/平' }}</span>
          </div>
          <div class="total-price">
            <span class="bold" v-if="houseItem.dealPrice">{{ dealPriceTag }}</span>
            <span class="unit-price" v-if="houseItem.dealPrice">万</span>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>
<script>
import houseServer from "@/services/houseServer.js";
import Constant from "@/common/Constant";
import tool from "@/utils/tool";
import { mapState } from "vuex";
export default {
  props: {
    tradeType: {
      type: Number,
      required: true
    },
    houseItem: {
      type: Object,
      require: true
    }
  },
  computed: {
    ...mapState(["user"]),
    path() {
      let result;
      if (this.tradeType === 1) {
        result = {
          name: "rent-house-detail",
          query: {
            guid: this.houseItem.guid,
            tradeType: this.tradeType
          }
        };
      } else {
        result = {
          name: "second-house-detail",
          query: {
            guid: this.houseItem.guid,
            tradeType: this.tradeType
          }
        };
      }
      return result;
    },
    mustSee() {
      const tag = this.houseItem.tag || [];
      //  || (this.houseItem.houseLevel || 0) == 1 ? true : false
      return tag.includes("必看好房") || tag.includes("礼包房源") || tag.includes("特惠好房")
    },
    mustSeeTag() {
      const tag = this.houseItem.tag || [];
      let tagText = ''
      if (tag.includes("礼包房源")) {
        return tagText = '礼包房源'
      } else if (tag.includes("特惠好房")) {
        return tagText = '特惠好房'
      } else if (tag.includes("必看好房")) {
        return tagText = '必看好房'
      }
      return tagText
    },
    decorateTag() {
      const decorate = this.houseItem.decorate;
      let decorateObj = this.moreData.decorate.filter((item) => { return item.value == decorate })
      let decorateText = decorateObj?.value || ''
      return decorateText
    },
    listingPriceTag() {
      let listingPriceText = Number(this.houseItem.listingPrice / 10000).toFixed(2)
      return listingPriceText
    },
    dealPriceTag() {
      let dealPriceText = Number(this.houseItem.dealPrice / 10000).toFixed(2)
      return dealPriceText
    },
  },
  data() {
    return {
      defaultCover: Constant.DEFAULT_HOUSE,
      showForceBox: false,
      moreData: {
        decorate: [
          {
            name: "不限",
            value: "1"
          },
          {
            name: "毛坯",
            value: "2"
          },
          {
            name: "简装",
            value: "3"
          },
          {
            name: "中装",
            value: "4"
          },
          {
            name: "精装",
            value: "5"
          },
          {
            name: "豪装",
            value: "6"
          }
        ],
        property: [
          {
            name: "住宅",
            value: "2"
          },
          {
            name: "别墅",
            value: "7"
          },
          {
            name: "商业",
            value: "4"
          },
          {
            name: "写字楼",
            value: "8"
          },
          {
            name: "底楼商户",
            value: "3"
          }
        ],
        orientation: []
      },
    };
  },
  methods: {
    transforPrice(price) {
      return tool.transforNumber(price) + "元/平";
    },
    // 关注房源
    async chooseAttention(e) {
      if (!this.user?.customer?.phone) {
        //弹登录框
        this.$store.commit("updateState", {
          data: true,
          key: "showLogin",
        });
        return
      }
      /*  tradeType 1:租房 2:售房 3:业主 4:小区 */
      const params = {
        houseGuid: e.guid,
        tradeType: 2,
      };
      if (e?.attention && e?.attention == true) {
        const [err, res] = await tool.to(houseServer.cancelCollection(params));
        if (res.code == 0) {
          this.$message.success('取消关注成功')
          this.houseItem.attention = false
        }
      } else {
        const [err, res] = await tool.to(houseServer.addCollection(params))
        if (res.code == 0) {
          this.$message.success('关注成功')
          this.houseItem.attention = true
        }
      }
    },
  },
  filters: {
    returnImage(url) {
      return url + Constant.IMG_HZ
    }
  },
};
</script>
<style lang="less" scoped>
.container {
  padding: 35px 0;
  border-bottom: 1px solid #f1f1f1;
  position: relative;

  .cover-img {
    display: block;
    position: relative;
    width: 232px;
    height: 174px;
    border: 1px solid #eeeeee;
    border-radius: 2px;

    .vr-logo {
      width: 30px;
      height: 30px;
      position: absolute;
      left: 8px;
      bottom: 8px;
    }
  }

  .info {
    width: 640px;
    vertical-align: top;
    color: #616669;
    font-size: 14px;

    .info-title {
      &:hover {
        text-decoration: underline;
      }
    }

    .good-house {
      margin-left: 5px;
      padding: 0 5px;
      text-align: center;
      color: #fff;
      font-size: 12px;
      line-height: 21px;
      height: 21px;
      background-color: #d53c3c;
    }

    .tag {
      color: #849aae;
      font-size: 12px;
      height: 30px;
      line-height: 30px;
      padding: 0 11px;
      margin-right: 6px;
      margin-bottom: 6px;
      background-color: #f4f7f9;
    }

    .price-info {
      position: absolute;
      right: 0;
      top: 0;
      color: #db4c3f;

      .total-price {
        margin-left: 120px;
        text-align: right;
        font-size: 20px;

        span {
          font-size: 22px;
          // font-family: tahoma;
          margin-right: 2px;
        }

        .unit-price {
          text-align: right;
          margin-top: 18px;
          width: 130px;
          font-size: 16px;
          font-weight: 400;
        }

      }

    }
  }

  .forceBox {
    position: absolute;
    right: 10px;
    top: 10px;
    padding: 2px 6px;
    color: #a9abab;
    border-radius: 2px;
    border: 1px solid #ddd;
    font-size: 12px;
    cursor: pointer;

    :hover {
      border-color: #666;
      color: #333;
    }
  }

}

.isAd {
  width: 100%;

  position: relative;

  img {
    width: 100%;
    height: auto;
    cursor: pointer;
  }

  .delIcon {
    float: right;
    width: 10px;
    height: 10px;
    position: absolute;
    right: 18px;
    top: 5px;
    cursor: pointer;

    &::after {
      content: '×';
      color: #fefefe;
      font-size: 14px;
    }

    &:hover {
      &::after {
        color: #fff;
        font-weight: 600;
      }
    }
  }
}
</style>


